import {useCallback} from 'react';
import {layerState} from '@src/store';
import {useRecoilState} from 'recoil';
import useNewLineText from '@src/hooks/useNewLineText';

function ConfirmLayer () {
  const [{data, callback}, setLayer] = useRecoilState(layerState);
  const {content, ok = '확인', cancel = '취소'} = data || {};
  const desc = useNewLineText(content);

  const handleClickClose = useCallback(() => {
    setLayer({open: false});
  }, [setLayer]);

  const handleClickConfirm = useCallback(() => {
    handleClickClose();
    callback && callback();
  }, [handleClickClose, callback]);

  return (
    // <!-- error 클레스 추가 -->
    <div className="inner_layer">
      <div className="layer_body">
        <p className="desc_layer">{desc}</p>
      </div>
      <div className="layer_foot">
        <div className="bundle_btn">
          <button type="button" className="btn_cancel" onClick={handleClickClose}>
            {cancel}
          </button>
          <button
            type="button"
            className="btn_ok"
            onClick={handleClickConfirm}
            data-tiara-action-name={data.tiaraActionName || ''}
            data-tiara-action-kind={data.tiaraActionType || ''}
          >
            {ok}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ConfirmLayer;
